angular.module('bribac.views.templates', [
  'ngRoute',
  'bribac.translations',
  'bribac.services.routeAuth'
])

  .config(function(
    $routeProvider
  ) {
    $routeProvider.when('/templates', {
      templateUrl: 'templates-view.html',
      controller: 'TemplatesViewCtrl',
      controllerAs: '$ctrl',
      resolve: {access: function(routeAuth) {return routeAuth.requireAuth()}}
    })
  })

  .controller('TemplatesViewCtrl', function() {
    this.pages = [
      {
        i18n: 'views.templates.menuItems.schedule',
        href: '#!/templates/schedule',
        icon: 'icon icon--mainMenuItem icon--mainMenuItem--large fa fa-calendar'
      },
      {
        i18n: 'views.templates.menuItems.settings',
        href: '#!/templates/settings',
        icon: 'icon icon--mainMenuItem icon--mainMenuItem--large fa fa-cog'
      }
    ]
  })
